module.exports = __webpack_public_path__ + "static/media/Abraham Lincoln (I) - 1864.abdf480f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Abraham Lincoln (I) - 1864.jpg
// module id = 427
// module chunks = 0